const childRoutes = (prop) => [
  {
    path: 'evaluation-setting-list',
    name: prop + '.evaluation_setting_list',
    meta: { auth: true },
    component: () => import('../pages/evaluation-setting/List.vue')
  },
  {
    path: 'committee-name-list',
    name: prop + '.committee_name_list',
    meta: { auth: true },
    component: () => import('../pages/committee-name/List.vue')
  },
  {
    path: 'rehabilitation-type',
    name: prop + '.rehabilitation_type',
    meta: { auth: true },
    component: () => import('../pages/rehabilitation-type/List.vue')
  },
  {
    path: 'case-type',
    name: prop + '.case_type',
    meta: { auth: true },
    component: () => import('../pages/case-type/List.vue')
  },
  {
    path: 'committee-designations-list',
    name: prop + '.committee_designations_list',
    meta: { auth: true },
    component: () => import('../pages/committee-designations/List.vue')
  },
  {
    path: 'e-checklist',
    name: prop + '.e_checklist',
    meta: { auth: true },
    component: () => import('../pages/e-checklist/List.vue')
  },
  {
    path: 'e-checklist-form',
    name: prop + '.e_checklist_form',
    meta: { auth: true },
    component: () => import('../pages/e-checklist/Form.vue')
  },
  {
    path: 'committee-types-list',
    name: prop + '.committee_types_list',
    meta: { auth: true },
    component: () => import('../pages/committee-types/List.vue')
  },
  {
    path: 'institutional-school-name',
    name: prop + '.institutional_school_name',
    meta: { auth: true },
    component: () => import('../pages/institutional-school-name/List.vue')
  },
  {
    path: 'institutional-school-form',
    name: prop + '.institutional_school_form',
    meta: { auth: true },
    component: () => import('../pages/institutional-school-name/Form.vue')
  },
  // {
  //   path: 'institute-type-list',
  //   name: prop + '.institute_type_list',
  //   meta: { auth: true },
  //   component: () => import('../pages/institute-type/List.vue')
  // },
  {
    path: 'add-class',
    name: prop + '.add_class',
    meta: { auth: true },
    component: () => import('../pages/add-class/List.vue')
  },
  {
    path: 'exam-type',
    name: prop + '.exam_type',
    meta: { auth: true },
    component: () => import('../pages/exam-type/List.vue')
  },
  // {
  //   path: 'institute-name',
  //   name: prop + '.institute_name',
  //   meta: { auth: true },
  //   component: () => import('../pages/institute-name/List.vue')
  // },
  {
    path: 'course-information-list',
    name: prop + '.course_information_list',
    meta: { auth: true },
    component: () => import('../pages/course-information/List.vue')
  },
  {
    path: 'course-information-form',
    name: prop + '.course_information_form',
    meta: { auth: true },
    component: () => import('../pages/course-information/Form.vue')
  },
  {
    path: 'report-heading',
    name: prop + '.report-heding',
    meta: { auth: true },
    component: () => import('../pages/report-heading/List.vue')
  },
  {
    path: 'received-notifications',
    name: prop + '.received_notifications',
    meta: { auth: true },
    component: () => import('../pages/received-notifications/List.vue')
  },
  {
    path: 'foodlist',
    name: prop + '.foodlist',
    meta: { auth: true },
    component: () => import('../pages/foodlist/List.vue')
  }
]
const routes = [{
  path: '/child-service/configuration',
  name: 'child_service.configuration',
  component: () => import('@/layouts/ChildServiceLayout.vue'),
  meta: { auth: true },
  children: childRoutes('child_service.configuration')
}]

export default routes
